import { Story } from '../../types/story';

export const newYorkCall: Story = {
  id: 'new-york-call',
  title: 'The Call',
  excerpt: 'A business trip to New York. A phone call with his wife. And the moment everything changed.',
  city: 'New York',
  publishDate: '2026-01-05',
  readTime: '28 min read',
  tags: ['♂♀', 'psychological', 'intense', 'cuckolding'],
  categories: ['forbidden', 'intense'],
  intensity: 3,
  content: `I was walking down Fifth Avenue when she called. The November air was sharp, cutting through my coat, and the city was doing that thing it does at dusk—transforming from day to night in a matter of minutes, the buildings lighting up one by one like dominoes falling across the skyline.

"Hey," Sarah's voice came through, and I could hear something in it immediately. Not quite nervousness, but something adjacent to it.

"Hey baby. How's home?" I dodged a group of tourists stopped dead in the middle of the sidewalk, staring up at Rockefeller Center.

"It's... I need to talk to you about something."

My stomach dropped. Those words. Nobody ever says those words before good news.

"Okay." I kept walking, my feet carrying me south automatically. "What's going on?"

"I..." She paused. I could hear her breathing. "I did something. While you've been gone. And I need to tell you."

I stopped walking. A businessman in a suit nearly collided with me, shot me an annoyed look, kept going. The crowd flowed around me like water around a stone.

"What did you do?"

"Monday. I... I slept with someone."

The words hit me like a physical thing. I stood there on Fifth Avenue, people streaming past me, the city moving at its relentless pace while my world tilted sideways.

"You what?"

"I'm so sorry. I'm so, so sorry. But I can't... I can't lie to you. I can't pretend it didn't happen."

I started walking again, faster now, heading south. My heart was pounding.

"Who?"

"Someone I met. At the coffee shop near our house. We started talking and... it just happened."

"It just happened." My voice came out flat. "You just accidentally fell onto his dick."

"Michael, please—"

"How long have you known him?"

Silence.

"Sarah. How long?"

"I met him Monday morning."

I stopped again, this time at the corner of 47th Street. The Diamond District stretched out to my left, windows glittering with jewelry I'd never be able to afford.

"You met him Monday morning and fucked him the same day?"

"Yes." Her voice was small.

"Jesus Christ, Sarah. We've been married for six years."

"I know."

"And you just... what? Saw some guy at a coffee shop and decided to throw it all away?"

"I didn't throw anything away! I'm still here. I'm still your wife. I just... I needed to tell you. I needed to be honest."

I started walking again, heading toward Bryant Park. My hands were shaking.

"Why?"

"Why did I do it or why am I telling you?"

"Both. Either. I don't know."

She was quiet for a long moment. When she spoke, her voice was different. Softer.

"Because when he looked at me, I felt something I haven't felt in a long time. Like I was... visible. Like I mattered. Not just as your wife or someone's employee, but as me. As Sarah."

The words cut deeper than the affair itself.

"I look at you."

"Do you? When was the last time you really looked at me, Michael? Not just glanced at me over breakfast or kissed me goodnight out of habit. Really looked at me. Really saw me."

I couldn't answer. Because she was right.

I reached Bryant Park, the winter market set up with its little wooden stalls and twinkling lights. Couples walked hand in hand, drinking hot chocolate, laughing. I kept walking.

"Tell me about him."

"Michael—"

"I need to know. Please."

She sighed. "His name is David. He's... he's a photographer. Freelance. He was at the coffee shop editing photos on his laptop."

"What does he look like?"

"Why does that matter?"

"It matters. Tell me."

"He's... tall. Maybe 6'2". Dark hair, kind of messy. Fit. He runs marathons."

Taller than me. Fitter than me. I was 5'10" and hadn't seen the inside of a gym in two years.

"And you just started talking to him."

"He asked if the seat across from me was taken. We started talking about photography. He showed me some of his work. It was... beautiful. Raw. Honest."

I was at 42nd Street now, the New York Public Library rising up on my right, the stone lions guarding the entrance.

"And then what?"

"We talked for an hour. About art, about life, about everything. And then he asked if I wanted to see his studio. He said he had more work to show me."

"And you knew what that meant."

"Yes. I knew."

"But you went anyway."

"Yes."

I turned east on 42nd, heading toward Grand Central. The Chrysler Building rose up ahead of me, its art deco crown glowing against the darkening sky.

"Why, Sarah? Why would you do that?"

"Because I felt alive. For the first time in months, maybe years, I felt like someone actually wanted me. Not needed me, not depended on me, but wanted me."

"I want you."

"Do you? When was the last time you initiated sex? When was the last time you looked at me with actual desire instead of just... routine?"

I couldn't answer. Because she was right. Again.

"Tell me what happened. At his studio."

"Michael, I don't think—"

"Please. I need to understand."

I could hear her breathing change. Could hear something shift in her voice.

"We barely made it through the door. He pushed me against the wall and kissed me. Hard. Like he'd been thinking about it the entire walk over. Like he couldn't wait another second."

My cock was hardening despite everything. Despite the anger and hurt and betrayal.

"And you kissed him back."

"Yes. God, yes. I kissed him like I was drowning and he was air."

I was walking faster now, past Grand Central, heading toward the East Side. My breath was coming in short gasps.

"What else?"

"He took me to his bedroom. It was... messy. Unmade bed, clothes everywhere. Real. Not like our perfect house with everything in its place."

"I don't care about his fucking interior design, Sarah. What did he do to you?"

Silence. Then, quietly: "He undressed me slowly. Kissed every inch of skin as he exposed it. Told me I was beautiful. Told me he'd been thinking about this since the moment he saw me."

"And then?"

"And then he... he was different from you."

"Different how?"

"Michael—"

"Tell me."

"He was bigger. Thicker. When he... when he first pushed inside me, it hurt."

Something twisted in my stomach. Jealousy and arousal mixed together in a way I didn't understand.

"How much bigger?"

"I don't know. Maybe... maybe two inches longer? And definitely thicker. I could barely... I had to adjust."

I was at the corner of Lexington and 42nd now, the Chrysler Building right in front of me. I leaned against the building, trying to catch my breath.

"But you liked it."

"Yes." Her voice was barely a whisper. "I liked feeling full. Stretched. Like every nerve ending was alive."

"What position?"

"What?"

"What position were you in when he fucked you?"

Silence. Then: "Missionary. At first. He wanted to watch my face. Wanted to see me react to him."

"And then?"

"And then he flipped me over. Took me from behind. Grabbed my hips and... and controlled everything. The pace. The depth. Everything."

I'd never taken her like that. Never been that aggressive. Never thought she'd want it.

"Did you like that? Being controlled?"

"Yes. God, yes. I liked feeling... dominated. Taken. Like I was his."

The words should have destroyed me. Instead, my cock was throbbing, straining against my pants.

I started walking again, heading north on Lexington. I needed to move, needed to do something with the energy coursing through me.

"Did he make you come?"

"Yes."

"How many times?"

"Michael—"

"How many times, Sarah?"

"Three times. He made me come three times."

More than I'd made her come in the last month combined.

"What did he do differently?"

"Everything. Nothing. I don't know. He just... he paid attention. He watched my body. Learned what I liked. Adjusted. He made me feel like making me come was the most important thing in the world."

The words cut deep. Because I couldn't remember the last time I'd done that. The last time I'd really focused on her pleasure instead of just going through the motions.

"Tell me more. Tell me exactly what he did."

I was at 50th Street now, walking past closed storefronts and late-night delis. The city felt surreal, like I was moving through a dream.

"He started with his mouth. Kissed down my body. Spent... god, he spent twenty minutes just eating me out. Like he loved it. Like he couldn't get enough."

"And you came from that."

"Yes. The first time. Just from his tongue."

I'd never done that. Never made her come just from oral.

"And then?"

"And then he fucked me. Slow at first. So slow I was begging. And then harder. Faster. Until I came again, screaming his name."

"You screamed his name."

"Yes." She sounded almost defiant now. "I screamed his name while I came on his cock."

I should have been furious. Should have hung up and called a lawyer. Instead, I was rock hard, walking through Manhattan with my cock throbbing, listening to my wife describe another man.

"What about the third time?"

"He made me get on top. Rode him while he watched me. Told me how beautiful I looked. How perfect. How he loved watching me take his cock. And I came just from that. Just from his words and the way he looked at me and the feeling of him inside me."

I turned west on 59th Street, heading toward Central Park. The Plaza Hotel rose up on my right, lit up like a palace.

"Are you touching yourself right now?" I asked.

Silence.

"Sarah. Are you?"

"Yes." Her voice was barely a whisper. "I'm in our bed. Touching myself. Thinking about Monday."

"What are you thinking about?"

"About how he felt inside me. About how he made me feel. About how he looked at me like I was the only woman in the world."

I entered Central Park at the southeast corner, the trees dark shapes against the sky, the paths lit by old-fashioned lamps. The city noise faded slightly.

"I'm angry at you."

"I know."

"I'm so fucking angry I can barely think straight."

"I know. I'm sorry."

"But I'm also..." I trailed off.

"What?"

"I'm also hard. I'm walking through Central Park with my cock throbbing, listening to you describe another man's dick, and I'm so hard it hurts."

"Michael—"

"Tell me more. Tell me what his cock looked like."

"It was... thick. Veiny. Curved slightly upward. When he was hard, it was... god, it was beautiful."

"Did you suck it?"

"Yes."

"Did you like it?"

"Yes. I liked feeling it in my mouth. Liked hearing him groan. Liked the way he grabbed my hair and controlled the pace."

I was walking faster now, past the Pond, toward the center of the park. My cock was leaking, a wet spot forming on my pants.

"Did he come in your mouth?"

"No. He wanted to come inside me. Wanted to fill me up."

"And you let him."

"Yes. I let him come inside me. Let him fill me with his cum."

"Jesus, Sarah."

"I'm sorry. I'm so sorry. But I can't lie to you. I can't pretend it wasn't incredible."

I was at Bethesda Fountain now, the angel rising up in the darkness, wings spread. I sat down on the edge, my breath coming in gasps.

"Are you still touching yourself?"

"Yes. I'm so wet, Michael. Just talking about it makes me wet."

"Show me. Send me a picture."

"What?"

"Send me a picture of how wet you are."

A pause. Then my phone buzzed. I opened the message and there it was—her hand between her legs, fingers glistening.

"Fuck."

"Do you like it?"

"Yes. God, yes. I like seeing how wet you are. How turned on you are thinking about him."

"Are you touching yourself?"

"Not yet. But I'm going to."

I stood up, started walking again, heading north toward the Great Lawn. The path was darker here, fewer people.

"Tell me more. Tell me everything."

"What do you want to know?"

"Everything. Every detail. What did his body feel like? How did he smell? What sounds did he make?"

"He was... muscular. Not like bodybuilder muscular, but lean and strong. He smelled like soap and sweat and something else. Something masculine. And when he came, he groaned. This deep, primal sound that made me come again just from hearing it."

"You came when he came."

"Yes. Feeling him pulse inside me, hearing him groan, it pushed me over the edge."

I was at Belvedere Castle now, the gothic structure rising up from the rock. I climbed the stairs, my heart pounding.

"I need to know something."

"What?"

"Was he better than me?"

Silence.

"Sarah. Was he better than me?"

"He was... different. Not better. Different."

"That's not an answer."

"Michael—"

"Was. He. Better."

"Yes." The word came out in a rush. "Yes, he was better. He was bigger, he lasted longer, he made me come harder. He was better."

The words should have destroyed me. Instead, they made my cock throb harder.

I reached the top of the castle, looking out over the park, the city lights spreading out in every direction. I unzipped my pants, pulled out my cock.

"I'm touching myself now."

"Michael—"

"I'm standing on top of Belvedere Castle with my cock in my hand, thinking about you getting fucked by another man."

"Oh god."

"Tell me more. Tell me what you're doing right now."

"I'm... I'm rubbing my clit. Thinking about Monday. About how he felt inside me. About how he made me scream."

I started stroking, my hand moving slowly at first.

"Did he fuck you more than once?"

"Yes. Three times. Once in the afternoon. Once after dinner. Once the next morning before I left."

"You stayed the night."

"Yes. I told you I was at my sister's."

"And you fucked him three times."

"Yes. Each time was different. Each time was incredible."

"Tell me about the morning. Tell me about the last time."

"I woke up to him kissing my neck. His cock was already hard, pressing against me. He rolled me onto my stomach, spread my legs, and took me from behind. Slow and deep. Made me come before he did."

I was stroking faster now, my hand moving in time with her breathing.

"What did it feel like? His cock inside you?"

"It felt... perfect. Like he was made for me. Every thrust hit exactly the right spot. I came so hard I couldn't breathe."

"Fuck, Sarah."

"I'm close," she gasped. "Oh god, Michael, I'm so close."

"Come for me. Come while you think about him fucking you."

"Are you... are you okay with this?"

"I don't know. But right now, I don't care. Right now, I just want to hear you come."

"Oh god, oh god, I'm—"

She screamed. Actually screamed. A sound of pure ecstasy that I'd never heard from her before.

And that's when I lost it.

I came hard, harder than I'd come in years, my cock pulsing in my hand, cum shooting out over the castle wall, onto my pants, onto my hand. I groaned, not caring if anyone heard, not caring about anything except the release.

For a long moment, there was only breathing. Two people, in two different cities, connected by a phone line and something I still didn't fully understand.

"Michael?" Sarah's voice, small and uncertain.

"I'm here."

"Are you... are you okay?"

I looked out at the city. At the lights of Manhattan spreading out before me. At the Empire State Building in the distance, lit up in red and white.

"No. But I will be."

"What does this mean? For us?"

I started walking down the castle stairs, heading south through the park.

"I don't know. But I know I love you. And I know I want to come home. And I know we need to figure this out. Together."

"Do you... do you hate me?"

"No. I'm angry. I'm hurt. I'm confused as hell. But I don't hate you."

"I'm so sorry."

"I know. And I'm sorry too. For not seeing you. For not making you feel wanted. For letting us become... complacent."

I was at the southern edge of the park now, exiting onto Central Park South. The Plaza Hotel glowed on my left, horse-drawn carriages lined up waiting for tourists.

"I'm coming home tomorrow. And we're going to talk. Really talk. About everything. About what you need. About what I need. About whether we can fix this."

"Can we? Fix this?"

"I don't know. But I want to try. Do you?"

"Yes. God, yes. I want to try."

I hailed a cab, gave the driver the address of the Empire State Building.

"Where are you going?" Sarah asked.

"The Empire State Building. I need to see the city. Need to think."

"Okay."

"Sarah?"

"Yeah?"

"I need to know. Do you want to see him again?"

Silence.

"No. It was... it was one time. One moment. I don't want to see him again. I want to fix us."

Relief flooded through me.

"Okay. Good. That's... that's good."

The cab pulled up to the Empire State Building. I paid the driver, got out, stood on the sidewalk looking up at the art deco tower, at the lights at the top piercing the night sky.

"I'm here."

"At the Empire State Building?"

"Yeah. The observation deck is closed, but I just wanted to stand here. To feel the city. To feel... something."

"I love you, Michael."

"I love you too. I'll see you tomorrow."

"Okay. Goodnight."

"Goodnight."

I hung up, put my phone in my pocket, stood there on 34th Street with my pants still damp with cum, my heart still racing, my mind still spinning.

I'd come to New York for business. For a presentation. For a deal.

But I'd found something else. Something darker and more complicated and more honest than anything I'd allowed myself to feel in years.

Tomorrow I'd fly home. Tomorrow I'd face my wife and whatever came next.

But tonight, I stood at the base of the Empire State Building, looked up at the lights piercing the sky, and felt the city pulse around me.

New York. The city that never sleeps. The city where anything can happen.

The city where everything changed.`
};
